export const sessionToken = state => state.session;
